import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { EmailTemplateState } from '../../types/emailTemplate/emailTemplate.types';

// Base selector
const selectEmailTemplatesState = (state: RootState): EmailTemplateState =>
  state.emailTemplates;

// Memoized selectors
export const selectEmailTemplates = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.emailTemplates
);

export const selectSelectedEmailTemplate = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.selectedEmailTemplate
);

export const selectEmailTemplatesLoading = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.loading
);

export const selectEmailTemplatesError = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.error
);

export const selectEmailTemplatesSuccess = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) =>
    emailTemplatesState.createSuccess || emailTemplatesState.updateSuccess
);

export const selectEmailTemplatesCreateSuccess = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.createSuccess
);

export const selectEmailTemplatesUpdateSuccess = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.updateSuccess
);

// Derived selectors
export const selectEmailTemplateById = (id: string) =>
  createSelector([selectEmailTemplatesState], (emailTemplatesState) => {
    if (emailTemplatesState.emailTemplatesById[id]) {
      return emailTemplatesState.emailTemplatesById[id];
    }
    return emailTemplatesState.emailTemplates.find(
      (template) => template._id === id
    );
  });

export const selectEmailTemplateLoadingById = (id: string) =>
  createSelector([selectEmailTemplatesState], (emailTemplatesState) => {
    return emailTemplatesState.loadingById[id] === true;
  });

export const selectCheckLinksLoading = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.checkLinksLoading
);

export const selectCheckLinksResult = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.checkLinksResult
);

export const selectCheckLinksError = createSelector(
  [selectEmailTemplatesState],
  (emailTemplatesState) => emailTemplatesState.checkLinksError
);
